export default __webpack_public_path__ + "static/media/pattern-3.b60d46c0.png";